import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../components/Home.vue'
// import Search from '../components/Search.vue'

// 懒加载 动态加载
const Home = () => import('../business/home/index.vue')
const AboutUs = () => import('../business/aboutUs/index.vue')
const ProductCenter = () => import('../business/productCenter/index.vue')
const ProductDetails = () => import('../business/productDetails/index.vue')
const Customer = () => import('../business/customer/index.vue')
const News = () => import('../business/news/index.vue')
const HumanResources = () => import('../business/humanResources/index.vue')
const ContactUs = () => import('../business/contactUs/index.vue')

Vue.use(VueRouter)

// 路由操作 no-referrer 解决跨域问题
const routes = [
  {
    path: '/', component: Home, meta: {
      title: "深圳市中科卓软科技有限公司",
      name: "referrer",
      content: "no-referrer"
    }
  },
  { path: '/', redirect: '/aboutUs' },
  {
    path: '/aboutUs', component: AboutUs, meta: {
      title: "关于我们",
      name: "referrer",
      content: "no-referrer"
    }
  },
  { path: '/', redirect: '/productCenter' },
  {
    path: '/productCenter', component: ProductCenter, meta: {
      title: "产品中心",
      name: "referrer",
      content: "no-referrer"
    }
  },
  { path: '/', redirect: '/productDetails' },
  {
    path: '/productDetails', component: ProductDetails, meta: {
      title: "产品详情",
      name: "referrer",
      content: "no-referrer"
    }
  },
  { path: '/', redirect: '/customer' },
  {
    path: '/customer', component: Customer, meta: {
      title: "客户案例",
      name: "referrer",
      content: "no-referrer"
    }
  },
  { path: '/', redirect: '/news' },
  {
    path: '/news', component: News, meta: {
      title: "新闻中心",
      name: "referrer",
      content: "no-referrer"
    }
  },
  { path: '/', redirect: '/humanResources' },
  {
    path: '/humanResources', component: HumanResources, meta: {
      title: "人力资源",
      name: "referrer",
      content: "no-referrer"
    }
  },
  { path: '/', redirect: '/contactUs' },
  {
    path: '/contactUs', component: ContactUs, meta: {
      title: "联系方式",
      name: "referrer",
      content: "no-referrer"
    }
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.NODE_ENV === 'production' ? '' : '/',
  routes
})

export default router
